/**
 * Label-Ableitung für Buttons (LINK-Objekte). Spiegelbild der
 * deriveLabel-Funktion im Admin. Buttons speichern selbst kein Label,
 * sondern werden zur Render-Zeit gegen die aktuelle Config aufgelöst.
 */
import type { Button, IntercomConfig } from '@livepuls/types';

export function deriveLabel(b: Button, cfg: IntercomConfig): string {
  if (b.labelOverride) return b.labelOverride;
  // User-Panels zeigen NUR den Namen des Ziels (z. B. „2"), keinen Präfix.
  switch (b.type) {
    case 'intercom':
      return cfg.panels.find((p) => p.id === b.targetPanelId)?.name ?? '?';
    case 'partyline':
      return cfg.partylines.find((p) => p.id === b.partylineId)?.name ?? '?';
    case 'listen':
      if (b.targetPanelId) return cfg.panels.find((p) => p.id === b.targetPanelId)?.name ?? '?';
      if (b.partylineId) return cfg.partylines.find((p) => p.id === b.partylineId)?.name ?? '?';
      return 'Listen';
    case 'call-to-all':
      return 'Alle';
    case 'external':
      return b.externalId;
    case 'external-port': {
      const port = cfg.externalPorts?.find((p) => p.key === b.portKey);
      return port?.label ?? 'Port';
    }
    case 'external-device':
      return cfg.externalDevices?.find((d) => d.id === b.externalDeviceId)?.name ?? 'Gerät';
  }
}
